import Controller from '@ember/controller';
import { action } from '@ember/object';

class IFrameDirectHireController extends Controller {
  queryParams = ['freelancerId'];

  @action
  handleCancel() {
    window.parent.postMessage({ type: 'closeModal' }, '*');
  }

  @action
  handleComplete() {
    window.parent.location.href = '/brand/signup';
  }
}

export default IFrameDirectHireController;
